import React, { useEffect, useState } from "react";

import styles from "./OrderCloseForm.module.scss";

import { SubmitHandler, useForm } from "react-hook-form";
import { OrderProps, OptionsProps } from "../../types/order";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getOrderDetails,
  updateOrderDetails,
} from "../../features/orderDetails/orderDetailsSlice";
import { GET, POST } from "../../services/axios.service";
import Select from "react-select";
import { selectStyles } from "../../static/styles";

type IAddJobworkFormInput = {
  jobwork_party_id: number;
};

const AddJobworkForm = () => {
  const dispatch = useAppDispatch();
  const order = useAppSelector(getOrderDetails);

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IAddJobworkFormInput>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestError, setRequestError] = useState<string | null>(null);
  const [jobworkParties, setJobworkParties] = useState<OptionsProps[]>([]);
  const [selectedJobworkParty, setSelectedJobworkParty] = useState<number | null>(null);

  useEffect(() => {
    // Fetch jobwork parties for the current order's item
    const fetchJobworkParties = async () => {
      try {
        const response: any = await GET("/v1/worker/jobwork-parties", {
          item_id: order?.item_id,
        });
        if (response.data.status === "success") {
          const options: OptionsProps[] = response.data.data.map((party: any) => ({
            value: party.id,
            label: party.firm_name,
          }));
          setJobworkParties(options);
        }
      } catch (error) {
        console.error("Error fetching jobwork parties:", error);
      }
    };

    if (order?.item_id) {
      fetchJobworkParties();
    }
  }, [order?.item_id]);

  const onSubmit: SubmitHandler<IAddJobworkFormInput> = async (data) => {
    setIsLoading(true);
    setRequestError(null);

    try {
      if (selectedJobworkParty && order && order.id) {
        const requestObj = {
          order_id: order.id,
          jobwork_party_id: selectedJobworkParty,
        };

        await POST("/v1/worker/add-jobwork-to-order", requestObj)
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(
                updateOrderDetails(response.data.data || ({} as OrderProps))
              );
            } else {
              setRequestError(response.data.message);
            }
          })
          .catch((error: any) => {
            setRequestError(error.data.message);
          });
      } else {
        setRequestError("જોબવર્ક પાર્ટી પસંદ કરો.");
      }
    } catch (error) {
      setRequestError("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }

    setIsLoading(false);
  };

  const handleJobworkPartyChange = (value: number) => {
    setSelectedJobworkParty(value);
    setValue("jobwork_party_id", value);
  };

  return (
    <div className={styles.OrderCloseForm}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {requestError !== null && (
          <span className="text-red-500 text-center mt-8">{requestError}</span>
        )}

        <div className="mt-6">
          <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
            <Select
              value={jobworkParties.find((val) => val.value === selectedJobworkParty)}
              className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
              styles={selectStyles}
              placeholder={"જોબવર્ક પાર્ટી પસંદ કરો"}
              options={jobworkParties}
              onChange={(val: any) => handleJobworkPartyChange(val?.value)}
            />
          </div>
          {errors.jobwork_party_id && (
            <span className="text-red-500">જોબવર્ક પાર્ટી પસંદ કરો</span>
          )}

          <div className="w-full flex">
            <button
              className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "રાહ જુઓ..." : "જોબવર્ક ઉમેરો"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default AddJobworkForm;
